<template>
  <div class="ma-4 app">
    <div class="text-h4">Relatório de Chamadas</div>
    <v-tabs v-model="tabs" background-color="background">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs" class="app">
      <v-tab-item>
        <RelatorioChamadasDetalhado />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import RelatorioChamadasDetalhado from './RelatorioChamadasDetalhado'

export default {
  name: 'AbasRelatorios',
  components: { RelatorioChamadasDetalhado },
  data: () => ({
    tipos: 1,
    tab: null,
    tabs: 1,
    tipo: ['Detalhado'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
